var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { ModalButtonDefaultProps, ModalButtonDefaultText, ModalHookClassName, } from './types';
import cx from 'classnames';
import Component from '@arco-design/web-react/es/Modal/modal';
// @ts-ignore
import IconInfoCircleFill from '@arco-design/web-react/icon/react-icon/IconInfoCircleFill';
// @ts-ignore
import IconCheckCircleFill from '@arco-design/web-react/icon/react-icon/IconCheckCircleFill';
// @ts-ignore
import IconExclamationCircleFill from '@arco-design/web-react/icon/react-icon/IconExclamationCircleFill';
// @ts-ignore
import IconCloseCircleFill from '@arco-design/web-react/icon/react-icon/IconCloseCircleFill';
var iconLibrary = {
    CONFIRM: null,
    INFO: React.createElement(IconInfoCircleFill, null),
    SUCCESS: React.createElement(IconCheckCircleFill, null),
    WARNING: React.createElement(IconExclamationCircleFill, null),
    ERROR: React.createElement(IconCloseCircleFill, null),
};
var modifiedPropsHelper = function (props, type) {
    var _a;
    var className = props.className, _b = props.simple, simple = _b === void 0 ? false : _b, _c = props.icon, icon = _c === void 0 ? (_a = iconLibrary === null || iconLibrary === void 0 ? void 0 : iconLibrary[type]) !== null && _a !== void 0 ? _a : null : _c, _d = props.closable, closable = _d === void 0 ? false : _d, _e = props.okText, okText = _e === void 0 ? ModalButtonDefaultText.OK : _e, _f = props.cancelText, cancelText = _f === void 0 ? ModalButtonDefaultText.CANCEL : _f, okButtonProps = props.okButtonProps, cancelButtonProps = props.cancelButtonProps;
    var modifiedProps = {
        className: cx(className, ModalHookClassName.GENERAL, ModalHookClassName[type]),
        simple: simple,
        icon: icon,
        closable: closable,
        okText: okText,
        cancelText: cancelText,
        okButtonProps: __assign(__assign({}, ModalButtonDefaultProps), okButtonProps),
        cancelButtonProps: __assign(__assign({}, ModalButtonDefaultProps), cancelButtonProps),
    };
    return __assign(__assign({}, props), modifiedProps);
};
export var confirm = function (props) {
    return Component.confirm(modifiedPropsHelper(props, 'CONFIRM'));
};
export var info = function (props) {
    return Component.confirm(modifiedPropsHelper(props, 'INFO'));
};
export var success = function (props) {
    return Component.confirm(modifiedPropsHelper(props, 'SUCCESS'));
};
export var error = function (props) {
    return Component.confirm(modifiedPropsHelper(props, 'ERROR'));
};
export var warning = function (props) {
    return Component.confirm(modifiedPropsHelper(props, 'WARNING'));
};
//# sourceMappingURL=notifications.js.map